// extracted by mini-css-extract-plugin
export var arrow = "index-module--arrow--hYPSW";
export var container = "index-module--container--jT2l9";
export var descriptionBox = "index-module--descriptionBox--M+giC";
export var overlay = "index-module--overlay--JK8Pb";
export var overlayButton = "index-module--overlayButton--u9HuT";
export var subtitle = "index-module--subtitle--7g3L3";
export var title = "index-module--title--9GFu5";
export var viz = "index-module--viz--2DZxO";